import LoginForm from "../components/authentication/LoginForm";
import login_bg from '../assets/login_bg.jpg';

function Login() {
  return (
    <div className="container">
      <div className="row">
        <div className="col-md-5 d-flex align-items-left p-0">
          <img src={login_bg} alt="SEOLI" className="w-100 h-80" />
        </div>
        <div className="h-100 col-md-5 d-flex align-items-center">
          <LoginForm />
        </div>
      </div>
    </div>
  );
}

export default Login;